var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hide
    ? _c(
        "v-btn",
        _vm._b(
          {
            class: [
              !_vm.disabled ? _vm.gradient : null,
              _vm.color,
              _vm.outlined ? null : _vm.textColor,
              _vm.variant,
            ],
            attrs: {
              icon: _vm.round,
              outlined: _vm.outlined,
              fab: _vm.fab,
              right: _vm.right,
              absolute: _vm.absolute,
              fixed: _vm.fixed,
              bottom: _vm.bottom,
              loading: _vm.loading,
              disabled: _vm.disabled,
              href: _vm.href,
              plain: _vm.plain,
              small: _vm.small,
              large: _vm.large,
              "input-value": _vm.inputValue,
              text: _vm.flat,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("click")
              },
            },
          },
          "v-btn",
          _vm.$attrs,
          false
        ),
        [
          !_vm.round && !_vm.left
            ? _vm._t("default", function () {
                return [_vm._v(_vm._s(_vm.text))]
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.left && _vm.icon
            ? _c(
                "v-icon",
                {
                  attrs: {
                    right: !_vm.round ? true : false,
                    color: _vm.iconColor,
                  },
                },
                [_vm._v(_vm._s(_vm.icon))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.logo
            ? _c("jet-application-logo", {
                staticClass: "block h-9 w-auto",
                staticStyle: { height: "1rem !important" },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.left
            ? _c("v-icon", { attrs: { left: "" } }, [_vm._v(_vm._s(_vm.icon))])
            : _vm._e(),
          _vm._v(" "),
          _vm.left
            ? _vm._t("default", function () {
                return [_vm._v(_vm._s(_vm.text))]
              })
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }